import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { Radio, Form } from "antd";
import { documentsSearchStore } from "../../Stores/DocumentsSearchStore";
import { observer } from "mobx-react";

interface VirusFieldsProps extends WithTranslation {}

export const VirusFields = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<VirusFieldsProps> {
      initialRadioHandler() {
        if (documentsSearchStore.searchReqQueries.problematicWithZeroSize) {
          return "problematicWithZeroSize";
        } else if (documentsSearchStore.searchReqQueries.problematicWithMalware) {
          return "problematicWithMalware";
        } else {
          return null;
        }
      }
      render() {
        const { t } = this.props;

        return (
          <Form layout="vertical" name="virusFields">
            <Radio.Group
              defaultValue={this.initialRadioHandler}
              onChange={(e) => documentsSearchStore.setVirusRadioValue(e.target.value)}
              options={[
                { label: t("Files with size 0 bytes"), value: "problematicWithZeroSize" },
                { label: t("Blocked virus files"), value: "problematicWithMalware" },
              ]}
            />
          </Form>
        );
      }
    }
  )
);
